import type { FetcherWithComponents } from '@remix-run/react';
import type {
    CopyDesignBoardPinsMutation,
    MoveDesignBoardPinsMutation,
} from 'generated/graphql';
import { API_ACTIONS } from '@modules/design-board/config';
import type { PinFetcherFunction } from '@modules/design-board/component/right-side-drawer/DesignBoardDrawerSelectPinsBody';

interface PinBoardClickedAction {
    destinationBoardId: number;
    boardId: number;
    pinListString: string;
    onError: (errorMsg: string) => void;
}

export interface MoveToBoardClickedProps extends PinBoardClickedAction {
    pinFetcher: FetcherWithComponents<MoveDesignBoardPinsMutation>;
}

export interface CopyToBoardClickedProps extends PinBoardClickedAction {
    pinFetcher: FetcherWithComponents<CopyDesignBoardPinsMutation>;
}

export const moveToBoardClicked: PinFetcherFunction = (props) => {
    const { destinationBoardId, boardId, pinListString, onError, pinFetcher } =
        props;
    if (boardId === destinationBoardId) {
        onError('Cannot move pins to the same board');
    } else {
        pinFetcher.submit(
            {
                boardId: `${boardId}`,
                destinationBoardId: `${destinationBoardId}`,
                pinIds: pinListString,
                _action: API_ACTIONS.MOVE_DESIGN_BOARD_PINS,
            },
            {
                method: 'post',
            }
        );
    }
};

export const copyToBoardClicked: PinFetcherFunction = ({
    destinationBoardId,
    boardId,
    pinListString,
    onError,
    pinFetcher,
}) => {
    if (boardId === destinationBoardId) {
        onError('Cannot move pins to the same board');
    } else {
        pinFetcher.submit(
            {
                boardId: `${boardId}`,
                destinationBoardId: `${destinationBoardId}`,
                pinIds: pinListString,
                _action: API_ACTIONS.COPY_DESIGN_BOARD_PINS,
            },
            {
                method: 'post',
            }
        );
    }
};
